<template>
  <div>
      <div class="mt-20 text-center text-xs font-thin text-gray-300">
        By clicking “Continue with email” above, you acknowledge that you have read and understood, and agree to Ben's <a  class="inline underline bg-transparent cursor-pointer select-none box-border hover:text-violet-500">Terms & Conditions</a> and <a class="inline underline bg-transparent cursor-pointer select-none box-border hover:text-violet-500">Privacy Policy</a>.
      </div>
  </div>
</template>

<script>
  export default {
    name: 'termsConditions',
    props: {
    },
    computed:{
    },
    methods:{
    }
  };
</script>

<style>

</style>